import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'

// Минимальная инициализация: оба словаря грузим сразу — они компактные,
// ленивый split добавим, когда пакет ключей станет крупнее.

export type AppLocale = 'en-US' | 'ru-RU'

export const SUPPORTED_LOCALES: AppLocale[] = ['en-US', 'ru-RU']

export const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'en-US': en,
    'ru-RU': ru,
  },
})

export function detectInitialLocale(): AppLocale {
  // Priority: localStorage → Accept-Language → 'en-US'.
  // User profile sync делается в stores/locale.ts, когда пользователь залогинен.
  const stored = localStorage.getItem('bx_locale') as AppLocale | null
  if (stored && SUPPORTED_LOCALES.includes(stored)) return stored

  const nav = navigator.language || 'en'
  if (nav.toLowerCase().startsWith('ru')) return 'ru-RU'
  return 'en-US'
}

export function setLocale(loc: AppLocale): void {
  i18n.global.locale.value = loc
  localStorage.setItem('bx_locale', loc)
  document.documentElement.lang = loc.split('-')[0]
}
